export default "__VITE_PUBLIC_ASSET__d507a051__"